import {
  useCloseContextMenu,
  useContextMenuIsOpen,
  useContextMenuTarget,
} from '@frameio/shared/contexts';
import { Menu } from '@frameio/vapor';
import { ContextMenu } from '../../../../../project';
import type { WorkspaceProjectTarget } from '../../../../hooks';
import { MenuButton } from '../MenuButton';
import TEXT from './generated/TEXT/Project_ContextMenuButton';

type ContextMenuButtonProps = {
  onContextMenu: () => void;
  projectId: string;
};

export const ContextMenuButton = ({
  onContextMenu,
  projectId,
}: ContextMenuButtonProps) => {
  const closeContextMenu = useCloseContextMenu();

  const target = useContextMenuTarget<WorkspaceProjectTarget>();
  const showMenu =
    useContextMenuIsOpen() &&
    target?.type === 'project' &&
    target.id === projectId;

  return (
    <Menu
      content={<ContextMenu projectId={projectId} />}
      isShowing={showMenu}
      onRequestChange={(isShowing: boolean) => {
        if (!isShowing) {
          closeContextMenu();
        }
      }}
    >
      <MenuButton
        data-testid="project-row--menu-button"
        label={TEXT.ariaLabel}
        onClick={onContextMenu}
      />
    </Menu>
  );
};

TEXT.DEFINE({
  ariaLabel: 'Open project context menu',
});
